import { render, staticRenderFns } from "./AISearchStats.vue?vue&type=template&id=ed9592a6&scoped=true&"
import script from "./AISearchStats.vue?vue&type=script&lang=js&"
export * from "./AISearchStats.vue?vue&type=script&lang=js&"
import style0 from "./AISearchStats.vue?vue&type=style&index=0&id=ed9592a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9592a6",
  null
  
)

export default component.exports